import React from 'react';

export const QrCodVkBotSvg: React.FC = () => {
  return (
    <a
      href="https://vk.me/club237282762"
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg
        width="120"
        height="120"
        viewBox="0 0 792 792"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="792" height="792" fill="#ffffff" x="0" y="0" />
        <g fill="#000000">
          <g transform="translate(240,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,48) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(360,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,72) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,96) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,120) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,120) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,120) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,120) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,120) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,144) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,144) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,144) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,144) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,144) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,144) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,168) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,192) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,216) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(360,216) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,216) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,216) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,216) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,216) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(72,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(96,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(120,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(216,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,240) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(96,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,264) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(120,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(216,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(672,288) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(72,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(120,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(360,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,312) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(72,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(120,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,336) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(96,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(216,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,360) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(72,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(96,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,384) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(72,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(120,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,408) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(216,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(672,432) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,456) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,480) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(120,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(216,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(360,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,504) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(96,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(144,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(168,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(192,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(216,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(672,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,528) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,552) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,576) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,600) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(480,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(672,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(720,624) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(360,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(408,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,648) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(288,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(504,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(528,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(576,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(600,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,672) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(240,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(384,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(432,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(648,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(672,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(696,696) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(264,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(312,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(336,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(456,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(552,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(624,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(672,720) scale(4.12)">
            <rect width="6" height="6" />
          </g>
          <g transform="translate(48,48)">
            <g transform="scale(12)">
              <path d="M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z" />
            </g>
          </g>
          <g transform="translate(576,48)">
            <g transform="scale(12)">
              <path d="M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z" />
            </g>
          </g>
          <g transform="translate(48,576)">
            <g transform="scale(12)">
              <path d="M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z" />
            </g>
          </g>
          <g transform="translate(96,96)">
            <g transform="scale(12)">
              <circle cx="3" cy="3" r="3" />
            </g>
          </g>
          <g transform="translate(624,96)">
            <g transform="scale(12)">
              <circle cx="3" cy="3" r="3" />
            </g>
          </g>
          <g transform="translate(96,624)">
            <g transform="scale(12)">
              <circle cx="3" cy="3" r="3" />
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
};
